import { EVENT_BUNDLE_BUILDER } from '~~/constants/googleTagManager';
export const buildBundleBuilderAddToCartTags = ({ sku }: { sku: string }) => ({
  event: EVENT_BUNDLE_BUILDER.ITEM_ADD_TO_CART,
  product_id: sku,
});
